import React, { ReactNode } from "react";
import {
    DropContent,
    SideDropTitle,
    SideDropWrapper,
} from "./sideDropdownStyles";

export interface IProps {
    children: ReactNode;
    dropTitle: string;
    plusIcon?: ReactNode;
}

const SideDropdown = ({ children, dropTitle, plusIcon }: IProps) => {
    return (
        <>
            <SideDropWrapper>
                <SideDropTitle>
                    <span>{dropTitle}</span>
                    {plusIcon}
                </SideDropTitle>
                <DropContent>{children}</DropContent>
            </SideDropWrapper>
        </>
    );
};

export default SideDropdown;
